module.exports = __webpack_public_path__ + "img/slide9.64e1b03e.png";